import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GuiOptionsDto } from "../dto/gui-options-dto";
import { ResultInfoGenericDto } from '../dto/ResultInfoDto';

@Injectable({
  providedIn: 'root'
})
export class Erma2Service {

  constructor(
    private http: HttpClient
  ) { }


  private apiGetOptions: string = "api/Options/GetOptions";
  private apiErmaNavigation: string = "Navigation/GetNavigation";
  private readonly apiUjList: string = 'api/ErmaUj/UjListByCUJ/';


  getOptions(): Observable<GuiOptionsDto> {
    return this.http.get<GuiOptionsDto>(this.apiGetOptions);
  }

  getNavigation(Erma2Config: GuiOptionsDto): Observable<any> {
    return this.http.get(Erma2Config['baseUrl'] + this.apiErmaNavigation);
  }

  /**
  * Vrátí seznam UJ
  * @param cuj
  */
  getUjsByCuj(cuj: string): Observable<ResultInfoGenericDto<string[]>> {
    return this.http.get<ResultInfoGenericDto<string[]>>(this.apiUjList + cuj);
  }
}
